import { AfterViewInit, Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { ConfigProvider } from "../../../config-provider.service";
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MatCard, MatCardModule } from "@angular/material/card";
import { MatIconModule } from "@angular/material/icon";
import { NgFor, NgIf } from "@angular/common";
import { MatMenuModule } from "@angular/material/menu";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatButtonModule } from "@angular/material/button";
import { MatProgressBarModule } from "@angular/material/progress-bar";

@Component({
  selector: 'mobile-module-content',
  providers: [],
  styleUrls: ['./mobile-module-content.scss'],
  standalone: true,
  imports: [
    MatCardModule,
    NgIf,
    NgFor,
    MatIconModule,
    MatMenuModule,
    MatTooltipModule,
    MatButtonModule,
    TranslateModule,
    MatProgressBarModule,
  ],
  templateUrl: './mobile-module-content.html'
})
export class MobileModuleContentComponent implements AfterViewInit {
    @Input() public title = '';
    @Input() public titleSwitcher: ModuleMenu[] = [];
    @Input() public moreMenus: ModuleMenu[] = [];
    @Input() public shortcutMenus: ModuleMenu[] = [];
    @Input() public mainActions: ModuleMenu[] = [];
    @Input() public mainActionsPosition: 'top' | 'bottom' = 'bottom';
    @Input() public coverImage: string | null = null;
    @Input() public isLoading = false;
    @Input() public loaderPosition: 'top' | 'bottom' = 'bottom';
    @Input() public disableMainActionsWhenLoading = true;
    constructor(
        public conf: ConfigProvider,
        private _router: Router,
        private _translater: TranslateService
    ) {
    }

    public ngAfterViewInit() {
    }

    public onMenuClicked(menu: ModuleMenu): void {

        if (menu.onClick) {
            menu.onClick();
        } else if (menu.url) {
            this._router.navigateByUrl(menu.url);
        }
    }
}

export interface ModuleMenu {
    title: string;
    icon: string;
    url: string;
    onClick: any;
}
